import { put, call, take, fork } from 'redux-saga/effects'
import { courseGetSuccess } from 'src/reducers/course/action'
import { courseGetService } from 'src/api/course'
import { COURSE_GET } from 'src/reducers/course/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* courseGetFlow(payload) {
  try {
    const { id, callback } = payload
    const response = yield call(courseGetService, id)

    yield put(courseGetSuccess(response.data))
    yield put(operationSuccess())

    callback(response.data)
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* courseGetWatcher() {
  while (true) {
    const action = yield take(COURSE_GET)
    const { payload } = action

    yield fork(generalSaga, courseGetFlow, payload)
  }
}
